module.exports = __webpack_public_path__ + "feb47a20dd2a281a55f6521928d5759b.svg";